"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Engagement / Charte"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">

              <p className={"text-normal mb-8"}>
                  <strong>Engagement / Charte</strong> <br/><br/>

                  « Le concurrent le plus redoutable est celui qui ne se préoccupe jamais de vous, mais qui améliore sans cesse sa propre affaire. » <strong>Henry FORD, célèbre industriel</strong>
              </p>

              <h3 className={"text-center text-2xl font-bold font-exo-bold text-bleu-ciel mb-8"}>
                  L’Engagement de l’Office pour une Démarche Qualité
              </h3>

             <p className={"text-normal mb-8"}>
                 Dans le cadre de sa démarche Qualité, COTE D’IVOIRE TOURISME prend l’engagement de développer et de <strong>
                 mettre en œuvre ses actions auprès des visiteurs, des partenaires socio-professionnels et des collectivités
                 de manière à les satisfaire. Ainsi, le client : visiteur, élu, prestataire, est au centre de nos préoccupations.
             </strong>
             </p>

              <h3 className={"text-center text-2xl font-bold font-exo-bold text-bleu-ciel mb-8"}>
                  Côte d’Ivoire Tourisme <br/>
                  auprès de ses visiteurs s’engage à :
              </h3>

              <div className={"text-normal"}>
                  <ul className="list-disc list-inside text-lg mt-8">
                      <li className="li7">Proposer et assurer un accueil souriant,
                          personnalisé, multilingue, et adapté aux personnes en situation de handicap et avec des
                          horaires d’ouvertures en adéquation avec la fréquentation touristique.
                      </li>
                      <li className="li4">Assurer la même qualité d’accueil en face à face dans
                          nos bureaux, au téléphone ou sur les canaux numériques.
                      </li>
                      <li className="li4">Disposer d’information à jour en plusieurs langues, a
                          minima trilingue à mettre à disposition via une documentation gratuite.
                      </li>
                      <li className="li4">Proposer des services complémentaires à l’accueil :
                          wifi gratuit, billetterie, boutique.
                      </li>
                      <li className="li4">Ecouter de façon active la demande du visiteur, lui
                          donner une réponse éclairée par l’expertise du territoire des conseillères en séjour et
                          élargir la demande pour l’inciter à découvrir plus longuement la destination Côte d’Ivoire.
                      </li>
                      <li className="li4">Mettre en place un système d’écoute du visiteur et de
                          sa satisfaction : questionnaires de satisfaction, prise en compte des suggestions et des
                          remarques, traitement des réclamations.
                      </li>
                  </ul>
              </div>

              <h3 className={"text-center text-2xl font-bold font-exo-bold text-bleu-ciel mb-8"}>
                  Côte d’Ivoire Tourisme <br/>
                  auprès de ses partenaires socio-professionnels s’engage à :
              </h3>

              <div className={"text-normal"}>
                  <ul className="list-disc list-inside text-lg mt-8">
                      <li className="li7">Créer un espace prof en ligne sur le site de côte
                          d’ivoire tourisme pour rendre disponible et accessible l’information nécessaire pour leur
                          activité
                      </li>
                      <li className="li4">Accueillir les socio-professionnels, être à leur
                          écoute et les mettre en relation avec le service en adéquation avec leurs demandes pour une
                          relation privilégiée.
                      </li>
                      <li className="li4">Collaborer étroitement avec les socio-professionnels
                          via, notamment, un comité stratégique en vue d’établir une stratégie partagée.
                      </li>
                      <li className="li4">Proposer des services performants et innovants aux
                          socio-professionnels, répondre à leur demande de façon pertinente dans les 5 jours ouvrés au
                          maximum, à mettre en place des actions et à mesurer leur satisfaction.
                      </li>
                      <li className="li4">Créer et mettre à jour des dossiers individuels des
                          prestataires touristiques et à effectuer des visites personnalisées nécessaires à la bonne
                          connaissance des offres du territoire.
                      </li>
                  </ul>
              </div>

              <h3 className={"text-center text-2xl font-bold font-exo-bold text-bleu-ciel mb-8"}>
                  Côte d’Ivoire Tourisme <br/>
                  auprès de ses collectivités et de ses partenaires institutionnels s’engage à :
              </h3>

              <div className={"text-normal"}>
                  <ul className="list-disc list-inside text-lg mt-8">
                      <li className="li7">Mettre en œuvre la stratégie touristique de la
                          Communauté d’Agglomération, construite avec l’Office de Tourisme et en adéquation avec les
                          besoins du territoire, afin de permettre à la Communauté d’Agglomération de réaliser son
                          ambition pour cette activité économique.
                      </li>
                      <li className="li4">Accompagner les collectivités sur leurs équipements
                          structurants, ainsi que dans l’aménagement du territoire et leurs projets favorisant
                          l’installation d’activités et d’hébergements ou le développement d’événements.
                      </li>
                      <li className="li4">Développer les filières thématiques prioritaires avec
                          les collectivités et nos partenaires institutionnels, afin de soutenir la création et la mise
                          en marché de produits correspondants.
                      </li>
                      <li className="li4">Participer avec les collectivités et les partenaires
                          institutionnels à des actions communes en lien avec les missions de l’Office de Tourisme.
                      </li>
                      <li className="li4">Participer au réseau d’information, à la diffusion de
                          l’information et à l’observation touristique à l’échelle départementale, régionale et
                          nationale.
                      </li>
                  </ul>
              </div>

              <h3 className={"text-center text-2xl font-bold font-exo-bold text-bleu-ciel mb-8"}>
                  Pour respecter ses engagements auprès de ses cibles, <br/>
                  l’Office de Tourisme se réinvente en interne et s’engage à :
              </h3>

              <div className={"text-normal"}>
                  <ul className="list-disc list-inside text-lg mt-8">
                      <li>Définir avec ses partenaires et leur transmettre ses objectifs et plan d’actions, dont la
                          politique qualité, ainsi que ses bilans annuels, à évaluer ses actions et leur impact.
                      </li>
                      <li className="li12">Faire de la qualité un outil d’amélioration et de management des services,
                          avec l’animation quotidienne de la démarche.
                      </li>
                      <li className="li12">Gérer les ressources humaines, former régulièrement le personnel et lui
                          donner les moyens matériels de réaliser ses missions, intégrer le personnel non permanent ou
                          nouvel entrant, mettre en place une communication interne efficace.
                      </li>
                      <li className="li12">Assurer la qualité des services par le respect des procédures de la démarche
                          Qualité de l’ensemble de l’équipe, la collecte et l’analyse des indicateurs qualité, ainsi que
                          la mise en place et le suivi d’éventuelles actions préventives et correctives.
                      </li>
                  </ul>
              </div>

              <p className={"text-center text-xl font-bold font-exo-bold text-bleu-ciel mb-8"}>
                  L’ensemble de l’équipe de l’office du tourisme, conscients de leur responsabilité dans la recherche constante de la satisfaction de l’ensemble de ses clients, s’engage à développer la Qualité des actions dans ce but.
                  </p>
          </SectionPage>

        </div>
  );
}
